import styled from "styled-components";
export const SearchBarContainer = styled.div.withConfig({
  displayName: "search-barstyles__SearchBarContainer",
  componentId: "sc-1wrwgxd-0"
})(["width:", ";", " form{", "}& div{", "}"], ({
  width
}) => width, {
  display: "flex",
  flexDirection: "row"
}, {
  width: "100%"
}, {
  height: "2.25rem",
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))"
});
